import React from "react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { UiDrawer, UiTextBox, UiButton, UiSelect } from "../../../../components";
import "./style.scss";

const AddUserDrawer = ({
    open,
    onClose,
    formData,
    handleChange,
    roleOptions,
    salutationOptions,
    isFormValid,
    handleSave,
    handleMobileNumberChange,
    handlePasswordChange,
    handleConfirmPasswordChange,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword
}) => {
    return (
        <UiDrawer
            title="Create New User"
            open={open}
            onClose={onClose}
            width={500}
        >
            <div className="add-user-drawer-content">
                <div className="content-wrapper">
                    <div className="form-group">
                        <div style={{ padding: "10px" }}>
                            <label style={{ color: "#004d40", fontWeight: "500" }}>
                                Salutation <span style={{ color: 'red' }}>*</span>
                            </label>
                        </div>
                        <div style={{ padding: "0px 10px" }}>
                            <UiSelect
                                placeholder="Select"
                                options={salutationOptions}
                                value={formData?.salutation}
                                onChange={(value) => handleChange("salutation", value)}
                                showSearch={false}
                                autoComplete="off"
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <UiTextBox
                            label="First Name"
                            required
                            placeholder="Eg: Abc"
                            value={formData?.firstName}
                            onChange={(event) => handleChange("firstName", event.target.value)}
                            style={{ color: "#004d40" }}
                        />
                    </div>
                    <div className="form-group">
                        <UiTextBox
                            label="Middle Name"
                            placeholder="Eg: Xyz"
                            value={formData?.middleName}
                            onChange={(event) => handleChange("middleName", event.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <UiTextBox
                            label="Last Name"
                            required
                            placeholder="Eg: Abc"
                            value={formData?.lastName}
                            onChange={(event) => handleChange("lastName", event.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <UiTextBox
                            label="Mobile Number"
                            required
                            placeholder="10 digit mobile number"
                            value={formData?.mobileNumber}
                            onChange={handleMobileNumberChange}
                            maxLength={10}
                            inputMode="numeric"
                        />
                    </div>
                    <div className="form-group">
                        <UiTextBox
                            label="Email ID"
                            required
                            placeholder="Example@gmail.com"
                            value={formData?.emailId}
                            onChange={(event) => handleChange("emailId", event.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <div style={{ padding: "10px" }}>
                            <label style={{ color: "#004d40", fontWeight: "500" }}>
                                Role <span style={{ color: 'red' }}>*</span>
                            </label>
                        </div>
                        <div style={{ padding: "0px 10px" }}>
                            <UiSelect
                                placeholder="Select"
                                options={roleOptions}
                                value={formData?.role}
                                onChange={(value) => handleChange("role", value)}
                                showSearch={false}
                                autoComplete="off"
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div style={{ marginBottom: "16px" }}>
                            <UiTextBox
                                label="Password"
                                required
                                type={showPassword ? "text" : "password"}
                                name="new-password"
                                autoComplete="new-password"
                                value={formData?.password}
                                onChange={handlePasswordChange}
                                maxLength={16}
                                suffix={
                                    <span
                                        onClick={() => setShowPassword((previousValue) => !previousValue)}
                                        onMouseDown={(event) => event.preventDefault()}
                                        style={{ cursor: "pointer", color: "#999" }}
                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                        role="button"
                                    >
                                        {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                    </span>
                                }
                            />
                            {formData?.password && !/^(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).{1,16}$/.test(formData?.password) && (
                                <span style={{ color: "#ff4d4f", fontSize: "12px", padding: "0 10px", display: "block", marginTop: "4px" }}>
                                    Password must contain uppercase, lowercase, symbol and max 16 characters
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="form-group">
                        <div style={{ marginBottom: "16px" }}>
                            <UiTextBox
                                label="Re-Password"
                                required
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirm-new-password"
                                autoComplete="new-password"
                                value={formData?.confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                maxLength={16}
                                suffix={
                                    <span
                                        onClick={() => setShowConfirmPassword((previousValue) => !previousValue)}
                                        onMouseDown={(event) => event.preventDefault()}
                                        style={{ cursor: "pointer", color: "#999" }}
                                        aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
                                        role="button"
                                    >
                                        {showConfirmPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                    </span>
                                }
                            />
                            {formData?.confirmPassword && formData?.password !== formData?.confirmPassword && (
                                <span style={{ color: "#ff4d4f", fontSize: "12px", padding: "0 10px", display: "block", marginTop: "4px" }}>
                                    Passwords do not match
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="drawer-footer">
                    <UiButton
                        className="cancel-btn"
                        onClick={onClose}
                    >
                        Cancel
                    </UiButton>
                    <UiButton
                        className="save-btn"
                        onClick={handleSave}
                        disabled={!isFormValid}
                    >
                        Save
                    </UiButton>
                </div>
            </div>
        </UiDrawer>
    );
};

export default AddUserDrawer;
